import React from 'react';
import PropTypes from 'prop-types';

import { CurrentStatus, UserDevice, UserSession } from './Content';
import { TimeUpdate } from './Header';
import { mapHealthCheckUrl, useHealthCheck } from './utils';

const Diagnose = ({ timeResponse }) => {
  const { API_LIST, BYTEARK_API } = mapHealthCheckUrl();
  const {
    data: dataByteArk,
    loading: loadingByteArk,
    refetch: refetchByteArk,
  } = useHealthCheck(BYTEARK_API, timeResponse);

  // NOTE: This will cause unnecessary. Fix it if it cause performance issue
  const statusList = [
    useHealthCheck(API_LIST[0], timeResponse),
    useHealthCheck(API_LIST[1], timeResponse),
    useHealthCheck(API_LIST[2], timeResponse),
    useHealthCheck(API_LIST[3], timeResponse),
    useHealthCheck(API_LIST[4], timeResponse),
    // useHealthCheck(API_LIST[5]),
  ];

  return (
    <>
      <TimeUpdate statusList={statusList} refetchByteArk={refetchByteArk} />
      <UserSession />
      <UserDevice />
      <CurrentStatus
        dataByteArk={dataByteArk}
        loadingByteArk={loadingByteArk}
        statusList={statusList}
      />
    </>
  );
};

Diagnose.propTypes = {
  timeResponse: PropTypes.bool,
};

export default Diagnose;
